import { render } from "./MobileTabBar.vue?vue&type=template&id=8d522ace&scoped=true"
import script from "./MobileTabBar.vue?vue&type=script&lang=js"
export * from "./MobileTabBar.vue?vue&type=script&lang=js"

import "./MobileTabBar.vue?vue&type=style&index=0&id=8d522ace&scoped=true&lang=css"
import "./MobileTabBar.vue?vue&type=style&index=1&id=8d522ace&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d522ace"]])

export default __exports__